"use client";
import * as React from "react";
const SvgOpenRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M15 0h-4.49a1 1 0 0 0-1 1 1 1 0 0 0 1 1h2.06L2 12.57v-2.06a1 1 0 0 0-2 0V15a1 1 0 0 0 .99 1h4.49a1 1 0 0 0 1-1 1 1 0 0 0-1-1H3.41L14 3.4v2.08a1 1 0 0 0 2 0V1a1 1 0 0 0-.99-1z" }));
export {
  SvgOpenRound as default
};
